import { render, staticRenderFns } from "./WalletView.vue?vue&type=template&id=714cbeb0&"
import script from "./WalletView.vue?vue&type=script&lang=js&"
export * from "./WalletView.vue?vue&type=script&lang=js&"
import style0 from "./WalletView.vue?vue&type=style&index=0&id=714cbeb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports